<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <TeacherTabs
        :teacher="teacher"
        v-model="currentTab"
        @delete="deleteTeacher"
        @edit="editTeacher"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="teacher">
          <TeacherDetails :teacher="teacher"/>
        </v-tab-item>
        <v-tab-item value="school">
          <TeacherSchoolDetails :teacher="teacher"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { teachersService } from '../../utils/services/teachers.service';
  import TeacherTabs from '../../components/app/Teachers/TeacherTabs';
  import TeacherDetails from '../../components/app/Teachers/TeacherDetails';
  import TeacherSchoolDetails from '../../components/app/Teachers/TeacherSchoolDetails';
  import TeacherModal from '../../components/modals/Teachers/TeacherModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'TeacherShow',
    components: {
        Loader,
        TeacherTabs,
        TeacherDetails,
        TeacherSchoolDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        teacher: {},
      };
    },
    computed: {
      returnUrl() {
        return this.$route.query.returnUrl || '';
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchTeacher(id) {
        return teachersService.get(id)
        .then(response => {
          this.teacher = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteTeacher() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return teachersService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push({
                  path: this.returnUrl || `/${this.routeName.TEACHER}`,
                });
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editTeacher() {
          this.showModal({
              component: TeacherModal,
               data: {
                  stored: {
                    id: this.id,
                    return_url: this.returnUrl,
                  },
              },
              options: {
                title: this.$t('TEACHER'),
                onSave: (
                  form,
                  error,
                ) => teachersService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                  if (this.returnUrl) {
                    this.$router.push({ path: this.returnUrl });
                    return;
                  }
                  this.fetchTeacher(this.id);
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchTeacher(this.id);
      this.loading = false;
    },
  };
</script>
